import { configureStore } from '@reduxjs/toolkit';
import orderReducer from './slices/orderSlice';
import menuReducer from './slices/menuSlice';
import restaurantReducer from './slices/restaurantSlice';
import analyticsReducer from './slices/analyticsSlice';
import tableReducer from './slices/tableSlice';
import customerReducer from './slices/customerSlice';
import waiterRequestReducer from './slices/waiterRequestSlice';
import specialOfferReducer from './slices/specialOfferSlice';
import authReducer from './slices/authSlice';
import counterOrderReducer from './slices/counterOrderSlice';
import inventoryReducer from './slices/inventorySlice';
import notificationPopupReducer from './slices/notificationPopupSlice';
import orderModalReducer from './slices/orderModalSlice';

export const store = configureStore({
  reducer: {
    orders: orderReducer,
    menu: menuReducer,
    restaurants: restaurantReducer,
    analytics: analyticsReducer,
    tables: tableReducer,
    customers: customerReducer,
    waiterRequests: waiterRequestReducer,
    specialOffers: specialOfferReducer,
    auth: authReducer,
    counterOrders: counterOrderReducer,
    inventory: inventoryReducer,
    notificationPopup: notificationPopupReducer,
    orderModal: orderModalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredPaths: ['analytics.chartData'],
      },
    }),
});